<template>
  <ag-modal-container
    :title="$t('user.title.restoreUser')"
    width="900px"
    @close="back"
  >
    <div
      v-if="!loadingData && !userList.length"
      class="text-center title mt-5"
      v-text="$t('user.restore.noRemovedUser')"
    />

    <user-list
      v-else
      :value="userList"
      :selected.sync="selectedUserList"
      :loading="loadingData"
      light
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :disabled="loadingRestore"
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />

      <ag-confirm-dialog
        :title="$t('general.confirmation')"
        :message="restoreMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.restore')"
        validation-btn-color="accent"
        @confirm="restoreSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRestore"
            :disabled="!selectedUserList.length || loadingRestore"
            color="accent"
            class="ml-5"
            v-bind="attrs"
            v-on="on"
            v-text="$t('general.restore')"
          />
        </template>
      </ag-confirm-dialog>
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import _map from 'lodash/map'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import UserList from 'src/modules/user/components/UserList'

export default {
  name: 'CompanyUserRestoreContainer',
  components: {
    AgModalContainer,
    AgConfirmDialog,
    UserList,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      userList: [],
      selectedUserList: [],
      loadingData: false,
      loadingRestore: false,
    }
  },
  computed: {
    restoreMessage () {
      const count = this.selectedUserList.length
      return this.$tc('user.restore.confirm', count, { count })
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'CompanyUserRestore') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async fetchData () {
      this.loadingData = true
      this.userList = await Repositories.company.user.getList(this.companyId, { onlyDeleted: true })
      this.loadingData = false
    },
    async restoreSelected () {
      try {
        this.loadingRestore = true
        const count = this.selectedUserList.length
        await Repositories.company.user.restore(this.companyId, _map(this.selectedUserList, 'userId'))

        this.selectedUserList = []
        this.fetchData()

        const notification = this.$tc('user.restore.success', count, { count })
        this.showSuccessNotification(notification)
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loadingRestore = false
      }
    },
  },
}
</script>
